import {ChartOptions} from "chart.js";
import {numberFormatter} from "@/service/NumberFormatter";
import {dateHelper} from "@/service/DateHelper";

export const transactionsCountChartOptions: ChartOptions = {
    animation: {
        duration: 0
    },
    responsive: true,
    aspectRatio: 16/8,
    plugins: {
        legend: {
            display: false
        },
        tooltip: {
            callbacks: {
                label: function(context) {
                    return (context.dataset.label || '') +': ' + numberFormatter.formatNumber(context.raw as number);
                }
            }
        }
    },
    scales: {
        y: {
            ticks: {
                callback: function(value: number) {
                    return numberFormatter.formatNumber(value);
                }
            },
            stacked: true
        },
        x: {
            ticks: {
                callback: function(value: number): string {
                    return dateHelper.format(this.getLabelForValue(value), 'DD-MM');
                }
            },
            stacked: true
        }
    }
} as ChartOptions;